export const toEpochSeconds = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null;
    return Math.floor(date.getTime() / 1000);
};
